import React, { useState } from 'react';
import './Topbar.css';
import { FaToilet } from 'react-icons/fa';
import AddWashroomForm from './AddWashroomForm';

const Topbar = ({ onAddWashroom }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const handleOpenForm = () => {
    setIsFormOpen(true);
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
  };

  const handleSubmitWashroom = (washroomData) => {
    // Pass the data to the parent component
    if (onAddWashroom) {
      onAddWashroom(washroomData);
    }
    
    // Log the data for debugging
    console.log('Washroom data submitted:', washroomData);
  };

  return (
    <header className="topbar">
      <div className="topbar-content">
        <div className="logo-section">
          <FaToilet className="logo-icon" />
          <h1 className="topbar-title">Find Washroom</h1>
        </div>
        
        { <div className="nav-items">
          <button className="nav-button" onClick={handleOpenForm}>Add Washroom</button>
        </div> }
      </div>
      
      <AddWashroomForm 
        isOpen={isFormOpen} 
        onClose={handleCloseForm} 
        onSubmit={handleSubmitWashroom} 
      />
    </header>
  );
};

export default Topbar;
